export { AccessCard, type AccessCardProps } from "./AccessCard";
